import * as _ from 'lodash';
import * as types from '@/store/mutationTypes';
import { Pagination, DefaultPagination } from '@/utils/pagination';

export const mutations = {
    [types.SET_PAGINATION](state, paginationConfig) {
        state.pagination = paginationConfig;
    },

    [types.REMOVE_PAGINATION](state) {
        state.pagination = new Pagination();
    },

    [types.GO_TO_PAGE](state, pageNumber) {
        if (pageNumber <= DefaultPagination.firstPage) {
            state.pagination.pageNumber = DefaultPagination.firstPage;
        } else if (pageNumber > state.pagination.totalPages - 1) {
            state.pagination.pageNumber = state.pagination.totalPages - 1;
        } else {
            state.pagination.pageNumber = pageNumber;
        }
    },

    [types.SET_PAGE_SIZE](state, pageSize) {
        state.pagination.pageSize = pageSize;
    },

    [types.SET_PAGE_NUMBER](state, pageNumber) {
        state.pagination.pageNumber = pageNumber;
    },

    [types.SET_LOCATIONS](state, locations) {
        state.locations = locations;
    },

    [types.UPDATE_FILTERS](state, filters) {
        state.filters = filters;
    },

    [types.UPDATE_FILTERS_DROPDOWN](state, { property, checked, field }) {
        const filters = {
            ...state.filters[field],
            [property]: checked
        };
        state.filters[field] = filters;
    },

    [types.RESET_FILTERS](state) {
        _.keys(state.filters).forEach(item => {
            switch(item) {
                case 'grades':
                case 'ages':
                case 'locationIds':
                    return state.filters[item] = {};
                default:
                    return state.filters[item] = true;
            }
        });
    },

    [types.UPDATE_SEARCH](state, search) {
        state.searchQuery = search;
    },

    [types.UPDATE_SORTING](state, { sortBy, sortDirection }) {
        state.sortBy = sortBy;
        state.sortDirection = sortDirection;
    },
    [types.SET_MODAL_FILTERS](state, filters) {
        state.modalFilters = filters;
    },
    [types.RESET_MODAL_FILTERS](state) {
        state.modalFilters = {
            invoiceStatus: null,
        };
    },
};


// WEBPACK FOOTER //
// ./src/store/modules/pageOptions/mutations.js